import { string } from '../../../../../localization';
import {
  canDisplayTemplateFolderPath,
  getRequestForQuotation,
  isInspirationDesigner
} from '../../../../../redux/finalCheckActions';
import {
  REGEX,
  EMAIL_REGEX,
  INSPIRATION_STATE,
  GIFTWRAPS_CATEGORY
} from '../../../../../utilities/constants/Constants';
import {
  checkForDesignCompetition,
  checkForDesignEnterprise,
  couponCodeValue,
  isBelgiumAccount,
  isShippingDetailsEnabled,
  isTurkeyAccount,
  isWestcoastAccount
} from '../../../../../utilities/HelperFunctions/SignageHelperFunctions';
import {
  getLocationDetails,
  getCountryNameList,
  getStateNameList
} from '../../../../../services/api';
import { isEditLink, isPremiumApp } from '../../../../../utilities/HelperFunctions/HelperFunctions';

const validateInputField = value => {
  const regularExpression = REGEX.SCRIPT_FORMAT;
  const name = value ? value.replace(/^\s+/, '').replace(/\s+$/, '') : '';
  const obj = {
    name,
    isValid: regularExpression.test(name)
  };
  return obj;
};

const validateEmailField = value => {
  const email = value ? value.replace(/^\s+/, '').replace(/\s+$/, '') : '';
  const obj = {
    email,
    isValid: EMAIL_REGEX.test(email)
  };
  return obj;
};

export const shouldShowProjectNameField = () => dispatch => {
  if (!dispatch(isTurkeyAccount()) && !dispatch(isBelgiumAccount())) {
    return true;
  }
  return false;
};

export const validateProjectName = value => {
  const { isValid } = validateInputField(value);
  if (isValid) {
    return { isValid, errorMessage: '' };
  }
  return { isValid, errorMessage: string.PROJECT_NAME_ERROR_TEXT };
};

export const shouldShowFirstAndLastNameField = () => dispatch => {
  if (
    dispatch(isTurkeyAccount()) ||
    dispatch(isBelgiumAccount()) ||
    dispatch(isShippingDetailsEnabled())
  ) {
    return true;
  }
  return false;
};

export const validateFirstName = value => {
  const { isValid } = validateInputField(value);
  if (isValid) {
    return { isValid, errorMessage: '' };
  }
  return { isValid, errorMessage: string.INVALID_NAME_KEY };
};

export const validateLastName = value => {
  const { isValid } = validateInputField(value);
  if (isValid) {
    return { isValid, errorMessage: '' };
  }
  return { isValid, errorMessage: string.INVALID_NAME_KEY };
};

export const shouldShowAddressField = () => dispatch => {
  if (dispatch(isShippingDetailsEnabled()) && !dispatch(isWestcoastAccount())) {
    return true;
  }
  return false;
};

export const validateAddressField = value => {
  const { isValid } = validateInputField(value);
  if (isValid) {
    return { isValid, errorMessage: '' };
  }
  return { isValid, errorMessage: string.INVALID_ADDRESS_KEY };
};

export const shouldShowCityField = () => dispatch => {
  if (dispatch(isShippingDetailsEnabled()) && !dispatch(isWestcoastAccount())) {
    return true;
  }
  return false;
};

export const validateCityName = value => {
  const { isValid } = validateInputField(value);
  if (isValid) {
    return { isValid, errorMessage: '' };
  }
  return { isValid, errorMessage: string.INVALID_CITY_KEY };
};

export const shouldShowCountryField = () => dispatch => {
  if (dispatch(isShippingDetailsEnabled()) && !dispatch(isWestcoastAccount())) {
    return true;
  }
  return false;
};

export const fetchCountriesData = callback => {
  getLocationDetails()
    .then(locationResponse => {
      const response = locationResponse.data;
      const countryCode = response.data.country_code;
      getCountryNameList().then(countryResponse => {
        const countries = countryResponse.data.data;
        const countriesArray = [];
        let selectedCountry;

        const countryList = Object.keys(countries);
        countryList.forEach(i => {
          const countrydict = {};
          countrydict.value = i;
          countrydict.label = countries[i];
          if (countryCode == i) {
            selectedCountry = countrydict;
          }
          countriesArray.push(countrydict);
        });
        callback(countriesArray, selectedCountry);
      });
    })
    .catch(() => {});
};

export const shouldShowStateField = () => dispatch => {
  if (dispatch(isShippingDetailsEnabled()) && !dispatch(isWestcoastAccount())) {
    return true;
  }
  return false;
};

export const fetchStateData = (countryCode, callback) => {
  getStateNameList(countryCode)
    .then(responseData => {
      const responseDict = responseData.data.data;
      const statesArray = [];
      const statesData = Object.keys(responseDict);
      let hasZipCode;
      statesData.forEach(key => {
        const details = responseDict[key];
        hasZipCode = details.has_zip_code;

        Object.values(details.states).forEach(innerKey => {
          const newDict = {};
          newDict.value = innerKey;
          newDict.label = innerKey;
          statesArray.push(newDict);
        });
      });
      callback(statesArray, hasZipCode);
    })
    .catch(() => {});
};

export const shouldShowZipField = () => dispatch => {
  if (dispatch(isShippingDetailsEnabled()) && !dispatch(isWestcoastAccount())) {
    return true;
  }
  return false;
};

export const shouldShowPhoneNumberField = () => dispatch => {
  if (
    dispatch(isTurkeyAccount()) ||
    (dispatch(isShippingDetailsEnabled()) && !dispatch(isWestcoastAccount()))
  ) {
    return true;
  }
  return false;
};

export const validatePhoneNumber = value => {
  const { isValid } = validateInputField(value);
  if (isValid) {
    return { isValid, errorMessage: '' };
  }
  return { isValid, errorMessage: string.INVALID_PHONE_NUMBER_KEY };
};

export const shouldShowCustomerNameField = () => (dispatch, getState) => {
  if (
    getState().modal.envData.wallart_lite_external_link &&
    !dispatch(isTurkeyAccount()) &&
    !dispatch(isBelgiumAccount()) &&
    !dispatch(isWestcoastAccount()) &&
    !dispatch(isShippingDetailsEnabled()) &&
    !getState().finalCheck.project.posCode
  ) {
    return true;
  }
  return false;
};

export const validateCustomerName = value => {
  const { isValid } = validateInputField(value);
  if (isValid) {
    return { isValid, errorMessage: '' };
  }
  return { isValid, errorMessage: string.INVALID_NAME_KEY };
};

export const shouldShowCustomerEmailField = () => (dispatch, getState) =>
  !getState().finalCheck.project.posCode;

export const validateCustomerEmail = value => {
  const { isValid } = validateEmailField(value);
  if (isValid) {
    return { isValid, errorMessage: '' };
  }
  return { isValid, errorMessage: string.INVALID_EMAIL_ADDRESS_KEY };
};

export const shouldShowCompanyNameField = () => dispatch => {
  if (
    (dispatch(checkForDesignCompetition()) ||
      dispatch(checkForDesignEnterprise())) &&
    !dispatch(isBelgiumAccount())
  ) {
    return true;
  }
  return false;
};

export const validateCompanyName = value => {
  const { isValid } = validateInputField(value);
  if (isValid) {
    return { isValid, errorMessage: '' };
  }
  return { isValid, errorMessage: string.INVALID_COMPANY_NAME };
};

export const shouldShowPostalAddressField = () => dispatch => {
  if (
    (dispatch(isTurkeyAccount()) || dispatch(isBelgiumAccount())) &&
    !dispatch(checkForDesignCompetition())
  ) {
    return true;
  }
  return false;
};

export const validatePostalAddressField = value => {
  const { isValid } = validateInputField(value);
  if (isValid) {
    return { isValid, errorMessage: '' };
  }
  return { isValid, errorMessage: string.INVALID_POSTAL_ADDRESS };
};

export const shouldShowOrderNumberField = () => dispatch => {
  if (
    couponCodeValue() &&
    dispatch(isShippingDetailsEnabled()) &&
    !dispatch(isWestcoastAccount())
  ) {
    return true;
  }
  return false;
};

export const shouldShowInvoiceUploadField = () => dispatch => {
  if (
    dispatch(isTurkeyAccount()) &&
    !(
      dispatch(checkForDesignCompetition()) ||
      dispatch(checkForDesignEnterprise())
    )
  ) {
    return true;
  }
  return false;
};

export const validateInvoiceFile = file => {
  let isValid = false;
  if (file) {
    isValid = true;
  }
  if (isValid) {
    return { isValid, errorMessage: '' };
  }
  return { isValid, errorMessage: '' };
};

export const shouldShowSerialNumberField = () => dispatch =>
  dispatch(isBelgiumAccount()) &&
  !(
    dispatch(checkForDesignCompetition()) ||
    dispatch(checkForDesignEnterprise())
  );

export const validateSerialNumber = value => {
  let isValid = false;
  if (value && value !== '') {
    isValid = true;
  }
  if (isValid) {
    return { isValid, errorMessage: '' };
  }
  return { isValid, errorMessage: string.INVOICE_FILE_MISSING };
};

export const shouldShowExtraInfoField = () => () => true;

export const validateExtraInfo = value => {
  let isValid = false;
  if (value && value !== '') {
    isValid = true;
  }
  if (isValid) {
    return { isValid, errorMessage: '' };
  }
  return { isValid, errorMessage: string.INVALID_INFO_KEY };
};

export const shouldShowInstallationInstruction = () => (dispatch, getState) => {
  const requestForQuotation = dispatch(getRequestForQuotation());
  const inspirationDesigner = getState().modal.envData.inspiration_designer;

  const { category } = getState().modal.envData;
  const { posCode, state } = getState().finalCheck.project;
  if (
    posCode ||
    requestForQuotation ||
    inspirationDesigner ||
    state === INSPIRATION_STATE ||
    category === GIFTWRAPS_CATEGORY ||
    isPremiumApp(getState().modal.envData)
  ) {
    return false;
  }
  return true;
};

export const shouldShowCheckBoxForTurkey = () => dispatch => {
  if (dispatch(isTurkeyAccount()) || dispatch(isBelgiumAccount())) {
    return true;
  }
  return false;
};

export const shouldShowPrivacyStatementLink = () => (dispatch, getState) => {
  const { language } = getState().home;
  if (language === 'tr') {
    return true;
  }
  return false;
};

export const getOrderButtonTitle = () => (dispatch, getState) => {
  let placeOrderButtonTitle = string.ADD_TO_ORDER_KEY;
  const designCompetition = dispatch(checkForDesignCompetition());
  const requestForQuotation = dispatch(getRequestForQuotation());
  const isTurkey = dispatch(isTurkeyAccount());
  const isBelgium = dispatch(isBelgiumAccount());
  if (getState().modal.envData.wallart_lite_web_link) {
    if (requestForQuotation) {
      placeOrderButtonTitle = string.REQUEST_FOR_QUOTATION;
    } else {
      placeOrderButtonTitle = string.ADD_TO_CART;
    }
  } else if (canDisplayTemplateFolderPath(getState) && isEditLink()) {
    placeOrderButtonTitle = string.SAVE_TEMPLATE;
  } else if (canDisplayTemplateFolderPath(getState)) {
    placeOrderButtonTitle = string.ADD_TEMPLATE;
  } else if (isInspirationDesigner(getState)) {
    placeOrderButtonTitle = string.SAVE_INSPIRATION;
  } else if (isTurkey || isBelgium) {
    placeOrderButtonTitle = string.ORDER_DESIGN;
    if (designCompetition) {
      placeOrderButtonTitle = string.SUBMIT_YOUR_DESIGN;
    }
  } else if (requestForQuotation) {
    placeOrderButtonTitle = string.REQUEST_FOR_QUOTATION;
  }

  return placeOrderButtonTitle;
};

// export const isBelgiumLaptop = () => (dispatch, getState) => {
//   const { sessionData, storeData } = getState().modal;
//   if (
//     sessionData.gsku === 'LPTS' &&
//     storeData.partnerStoreType === Constants.BELGIUM_KEY
//   ) {
//     return true;
//   }
//   return false;
// };
